import React from 'react';
import { Navigate } from 'react-router-dom';

// /login is a legacy MMS-era route that old bookmarks, old emails and GOOGLE
// still point at — it sits in the index from before the noindex meta actually
// rendered (2026-08-18), so unlisting it from the nav would have fixed the nav
// and done nothing about search. It forwards to the portal instead.
//
// Decided by Anthony 2026-08-20, and the reasoning is operational rather than
// technical: no lessons remain scheduled in MyMusicStaff, so nobody has a
// legitimate errand there. Anyone still trying to reach it is either not
// returning in the fall — in which case they need nothing — or is confused, in
// which case they need a person, not a login box. Running both doors open
// through the Aug 31 cutover was judged more confusing than closing one.
//
// MMS ITSELF STAYS UP UNTIL AUG 31. This closes the route through THIS site;
// a bookmark straight to mymusicstaff.com is unaffected and deliberately so.
// `LoginWidget` is kept, not deleted — the same call as the pack removal, so
// restoring the old page before the cutover is a one-line revert.
//
// Sibling precedent: /sign-up became <Navigate to='/register'> on 2026-08-18
// for the same class of reason. The route stays noindexed (utils/noindexRoutes).
const Login = () => {
	return <Navigate to='/portal/login' replace />;
};

export default Login;
